// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5qns3","title":"Header_title__2O2b0","left":"Header_left__3EGpA","clinicName":"Header_clinicName__VJlTI"};